(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7953],{

/***/ 7953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9815);
/* harmony import */ var _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8548);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _context_app__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9324);
/* harmony import */ var _Skelet__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3177);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3725);
/* harmony import */ var _styles_modules_favorites_FavoritesList_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2633);
/* harmony import */ var _styles_modules_favorites_FavoritesList_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_favorites_FavoritesList_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _objects_ObjectsCatalogSkeletonItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8171);
/* harmony import */ var _public_images_favorite_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8554);














var ObjectsCatalogItem = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(5518), __webpack_require__.e(3012), __webpack_require__.e(1303)]).then(__webpack_require__.bind(__webpack_require__, 3259));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3259)
            ];
        }
    },
    suspense: true
});
var FavoritesList = function() {
    /** STATES */ var appState = (0,_context_app__WEBPACK_IMPORTED_MODULE_5__/* .useAppState */ .mr)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isError = ref1[0], setIsError = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), data = ref2[0], setData = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), total = ref3[0], setTotal = ref3[1];
    /** HOOKS */ (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!appState.isLoaded) return;
        var fetchData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response;
                return _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setIsLoading(true);
                            _ctx.next = 3;
                            return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .sleep */ ._v)(300);
                        case 3:
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return axios__WEBPACK_IMPORTED_MODULE_4___default().post("https://baza.estate/api/v2" + "/favorites", {
                                ads: appState.favorites,
                                length: 50
                            });
                        case 6:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(response.data.text);
                        case 9:
                            setTotal(response.data.data.total);
                            setData(response.data.data.data);
                            setIsLoading(false);
                            setIsError(false);
                            _ctx.next = 19;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](3);
                            setIsLoading(false);
                            setIsError(true);
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        15
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, [
        appState.isLoaded
    ]);
    /** TEMPLATES */ if (isLoading || isError) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
        className: "block",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: [
                "fixed",
                (_styles_modules_favorites_FavoritesList_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favorites)
            ].join(" "),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: (_styles_modules_favorites_FavoritesList_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favoritesHeader),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        height: 33,
                        maxWidth: 200,
                        className: (_styles_modules_favorites_FavoritesList_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favoritesHeaderTitle)
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: (_styles_modules_favorites_FavoritesList_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favoritesContent),
                    children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(Array(3).keys()).map(function(value) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_objects_ObjectsCatalogSkeletonItem__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}, value);
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
        className: "block",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "fixed",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (_styles_modules_favorites_FavoritesList_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favorites),
                children: [
                    data.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (_styles_modules_favorites_FavoritesList_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favoritesHeader),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: (_styles_modules_favorites_FavoritesList_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favoritesHeaderTitle),
                            children: [
                                "Избранное",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                    children: [
                                        total,
                                        " ",
                                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .declOfNum */ .Ak)(total, [
                                            "объект",
                                            "объекта",
                                            "объектов"
                                        ])
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (_styles_modules_favorites_FavoritesList_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favoritesContent),
                        children: data.length > 0 ? data.map(function(v, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
                                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_objects_ObjectsCatalogSkeletonItem__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ObjectsCatalogItem, {
                                    item: v
                                })
                            }, i);
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_13__/* .motion.div */ .E.div, {
                            initial: {
                                opacity: 0,
                                scale: 0.5
                            },
                            animate: {
                                opacity: 1,
                                scale: 1,
                                transition: {
                                    duration: 1,
                                    type: "spring",
                                    bounce: 0.6
                                }
                            },
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h5", {
                                    style: {
                                        marginBottom: 8
                                    },
                                    children: "Нет объектов"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    style: {
                                        opacity: 0.6,
                                        textAlign: "center",
                                        margin: "0 18px"
                                    },
                                    children: [
                                        "Жмите",
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_public_images_favorite_svg__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
                                        " ",
                                        "на странице объекта и он(и) появятся здесь."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                    src: "/images/no_results.svg",
                                    alt: "",
                                    style: {
                                        width: "100%",
                                        maxWidth: 400,
                                        margin: "18px 32px"
                                    }
                                })
                            ]
                        })
                    }),
                    data.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (_styles_modules_favorites_FavoritesList_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favoritesFooter),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                style: {
                                    fontWeight: 600,
                                    marginRight: 4
                                },
                                children: "Внимание!"
                            }),
                            " выбранные Вами объекты хранятся только на Вашем устройстве"
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FavoritesList);


/***/ }),

/***/ 8171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Skelet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3177);
/* harmony import */ var _styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4062);
/* harmony import */ var _styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var ObjectsCatalogItem = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().item),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemGallery),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: {
                        height: "calc(100% - 4px)",
                        width: "auto",
                        borderRadius: 16,
                        margin: 2
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemData),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemPrice),
                        height: 46,
                        maxWidth: 200
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemAddress),
                        height: 21,
                        maxWidth: 240
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemProperties),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemProperty),
                                width: 60,
                                height: 32,
                                style: {
                                    marginRight: 12
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemProperty),
                                width: 60,
                                height: 32,
                                style: {
                                    marginRight: 12
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemProperty),
                                width: 60,
                                height: 32,
                                style: {
                                    marginRight: 12
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemDescription),
                        height: 110
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemActions),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_modules_objects_ObjectsCatalogItem_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemDate)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                width: 150,
                                height: 50,
                                style: {
                                    borderRadius: 12
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ObjectsCatalogItem);


/***/ }),

/***/ 2633:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"favorites":"FavoritesList_favorites__YeCjc","favoritesHeader":"FavoritesList_favoritesHeader__4Wsi3","favoritesHeaderTitle":"FavoritesList_favoritesHeaderTitle__Z_VNA","favoritesHeaderActions":"FavoritesList_favoritesHeaderActions__Ckt1b","favoritesMapButton":"FavoritesList_favoritesMapButton__tqTM2","favoritesHeaderSort":"FavoritesList_favoritesHeaderSort__sQUqI","up":"FavoritesList_up__57h5n","favoritesContent":"FavoritesList_favoritesContent__wu9XR","favoritesFooter":"FavoritesList_favoritesFooter__9fBJx"};

/***/ }),

/***/ 4062:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"ObjectsCatalogItem_item__1ZMCX","itemGallery":"ObjectsCatalogItem_itemGallery__NCwCX","itemGalleryCounter":"ObjectsCatalogItem_itemGalleryCounter__gwd2w","itemGalleryButtons":"ObjectsCatalogItem_itemGalleryButtons__VHbxU","itemGalleryButtonLeft":"ObjectsCatalogItem_itemGalleryButtonLeft__zVeXw","itemGalleryButtonRight":"ObjectsCatalogItem_itemGalleryButtonRight__S1vOQ","itemGalleryPhotos":"ObjectsCatalogItem_itemGalleryPhotos__B9SNX","itemGalleryPhoto":"ObjectsCatalogItem_itemGalleryPhoto__gDJpY","itemGalleryPhotoHash":"ObjectsCatalogItem_itemGalleryPhotoHash__INhPB","itemGalleryPhotoMore":"ObjectsCatalogItem_itemGalleryPhotoMore__ive6N","itemGalleryPhotoMoreText":"ObjectsCatalogItem_itemGalleryPhotoMoreText__dOZyX","itemLabels":"ObjectsCatalogItem_itemLabels__IYVcB","itemLabelsItem":"ObjectsCatalogItem_itemLabelsItem__M_Uo_","yellow":"ObjectsCatalogItem_yellow__rYPoE","red":"ObjectsCatalogItem_red__bnkB1","itemData":"ObjectsCatalogItem_itemData__azZrz","itemPrice":"ObjectsCatalogItem_itemPrice__5ZYQA","green":"ObjectsCatalogItem_green__JY1JX","itemActionsFavorites":"ObjectsCatalogItem_itemActionsFavorites__JYrxM","active":"ObjectsCatalogItem_active__GVnm9","itemOldPrice":"ObjectsCatalogItem_itemOldPrice__eV0ML","itemAddress":"ObjectsCatalogItem_itemAddress__6CFms","itemProperties":"ObjectsCatalogItem_itemProperties__ENt9e","itemProperty":"ObjectsCatalogItem_itemProperty__OfsQQ","itemDescription":"ObjectsCatalogItem_itemDescription__tCe7V","itemActions":"ObjectsCatalogItem_itemActions__w6rGN","itemDate":"ObjectsCatalogItem_itemDate__tR0B_","itemFavorites":"ObjectsCatalogItem_itemFavorites__U7fsE","qr":"ObjectsCatalogItem_qr__Z_W4o"};

/***/ })

}]);